import { darken } from '@mui/material';

export const COLORS = {
    contrastText: '#FFFFFF', // Contrast Text
    primary: {
        light: '#34588E', // Alternative Light
        main: '#10428E', // Main
        dark: '#0A2A5B', // Alternative Dark
        containedHover: '#648CC8', // Contained Hover Background
        outlinedHover: '#EBF1FA', // Outlined Hover Background
        outlinedResting: '#C3D5F1', // Outlined Resting Background
    },
    secondary: {
        light: '#9C9FA4',
        main: '#4D4D4D',
        dark: '#333333',
        containedHover: '#777B82',
        outlinedHover: '#C2C2C2',
        outlinedResting: '#F3F3F3',
    },
    info: {
        light: '#32BAFF',
        main: '#16B1FF',
        dark: '#0E71A3',
        containedHover: '#139CE0',
        outlinedHover: '#32BAFF14',
        outlinedResting: '#32BAFF80',
    },
    success: {
        light: '#6AD01F',
        main: '#56CA00',
        dark: '#378100',
        containedHover: '#4CB200',
        outlinedHover: '#56CA0014',
        outlinedResting: '#56CA0080',
    },
    warning: {
        light: '#FFB547',
        main: '#FFB400',
        dark: '#A37300',
        containedHover: '#E09E00',
        outlinedHover: '#FFB40014',
        outlinedResting: '#FFB40080',
    },
    error: {
        light: '#FF6166',
        main: '#FF4C51',
        dark: '#A33134',
        containedHover: '#E04347',
        outlinedHover: '#FF4C5114',
        outlinedResting: '#FF4C5180',
    },
};

export const DARK_COLORS = {
    contrastText: '#FFFFFF',
    primary: {
        light: '#0A2A5B',
        main: '#10428E',
        dark: '#34588E',
        containedHover: darken('#10428E', 0.2), // ~ '#0D3572'
        outlinedHover: darken('#C3D5F1', 0.2), // ~ '#9CAAC0'
        outlinedResting: darken('#EBF1FA', 0.2), // ~ '#BCC0C8'
    },
};
